import { BN } from "bn.js";

export const q6464ToF64 = (input): number => {
  const scaleFactor = new BN(2).pow(new BN(64)).subn(1);
  const inputBN = typeof input === "number" ? new BN(input) : input;
  const result = inputBN.div(scaleFactor);
  return result.toNumber();
};

export const f64ToQ6464 = (input: number) => {
  const scaleFactor = new BN(2).pow(new BN(64)).subn(1);
  return new BN(input).mul(scaleFactor);
};
